module.exports = __webpack_public_path__ + "img/product-category-weddingrings@2x.5246cfa.webp";